import "./OurHistory.module.css";
import Cabecera from "@/reusable_sections/Header";
import FamilyHistory from "./sections/FamilyHistory";
import Valores from "./sections/Valores";
import NuestraHistoria from "./sections/NuestraHistoria";
import PieDePagena from "@/reusable_sections/Footer";
export default function OurHistoryPage() {
  return <div>
      <Cabecera />
      <FamilyHistory />
      <NuestraHistoria />
      <Valores />
      <PieDePagena />
    </div>;
}